import { render, staticRenderFns } from "./EthicalAdvicesPage.vue?vue&type=template&id=ceff9b6c&"
import script from "./EthicalAdvicesPage.vue?vue&type=script&lang=js&"
export * from "./EthicalAdvicesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports